  (function(){
    window.addEventListener("load",function(){
      var productHeader = document.querySelector(".product-tip-header");
      var productContent = document.querySelector(".product-tip-content");
      if(productHeader){
         productHeader.addEventListener("mouseenter",function(){
          productContent.style.display = "block";
        })
        productHeader.addEventListener("mouseleave",function(){
          productContent.style.display = "none";
        }) 
      }
    })
  })();
  (function(){
    window.addEventListener("load",function(){
      let items = document.querySelectorAll("#t4s-menu-drawer .menu2-modify-item");
      let menu = document.querySelectorAll("#t4s-menu-drawer .desktop-menu");
      let menuText = document.querySelector("#t4s-menu-drawer .modify-menu-text");
      // console.log(items,menu)
      for(let i = 0;i<items.length;i++){
        items[i].setAttribute("index",i);
        items[i].addEventListener("click",function(){
          for(let j = 0;j<items.length;j++){
            items[j].style.display = "none";
          }
          // this.style.display = "block";
          
          for(let k = 0;k<menu.length;k++){
            menu[k].style.display = "none";
          }
          menu[this.getAttribute("index")].style.display = "block";

          let itemTwo = document.querySelectorAll("#t4s-menu-drawer .menu2-modify-item-link");
          for(let i = 0;i<itemTwo.length;i++){
            itemTwo[i].style.display = "none";
          }

          menuText.innerHTML = `<i class="las la-arrow-left"></i>${this.innerText}`;
        })
      }
      menuText.addEventListener("click",function(){
          for(let j = 0;j<items.length;j++){
            items[j].style.display = "flex";
          }
          for(let k = 0;k<menu.length;k++){
            menu[k].style.display = "none";
          }

          let itemTwo = document.querySelectorAll("#t4s-menu-drawer .menu2-modify-item-link");
          for(let i = 0;i<itemTwo.length;i++){
            itemTwo[i].style.display = "flex";
          }
        
          menuText.innerHTML = `Menu`;
      })
    })

  })();